import React, {Component} from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import Overlay from '../../../../presentation/Overlay';

class AniTraceRecordsDialog extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      call: props.call === undefined ? {} : props.call,
      show: props.show === undefined ? false : props.show,
      width: props.width === undefined ? "auto" : props.width,
      height: props.height === undefined ? "auto" : props.height,
    };

    this.onHandleClose = this.onHandleClose.bind( this );
  }

  static getDerivedStateFromProps ( props, state ) {
    let newState = state;
    let stateChanged = false;

    if( props.call !== undefined && state.call !== undefined ) {
      if( Object.keys( props.call ).length !== Object.keys( state.call ).length ) {
        newState.call = props.call;
        stateChanged = true;
      }
    }

    if( props.show !== undefined ) {
      if( props.show !== state.show ) {
        newState.show = props.show;
        stateChanged = true;
      }
    }

    if( props.width !== undefined ) {
      if( props.width !== state.width ) {
        newState.width = props.width;
        stateChanged = true;
      }
    }

    if( props.height !== undefined ) {
      if( props.height !== state.height ) {
        newState.height = props.height;
        stateChanged = true;
      }
    }

    if( stateChanged === true ) {
      return newState;
    }

    return null;
  }

  /* Parse the incoming messages from an ANI Trace */
  parseMessage( message ) { 
    const newMessage = message.split( "&" ).join(" ").split("=").join(": ");
    return newMessage;
  }
  
  onHandleClose( e ) {
    if( this.props.onClose !== undefined ) {
      this.props.onClose( e );
    }
  }

  onRenderInfo( ) {
    const call = this.state.call;
    return (
      <div className="anitrace-records-info">
        <strong>
          Call ID:
        </strong>
        <span>
          {call.CLIENT_ID}
        </span>
        <strong>
          ANI:
        </strong>
        <span>
          {call.ANI}
        </span>
        <strong>
          Number Dialed:
        </strong>
        <span>
          {call.NUMBER_DIALED}
        </span>
        <strong>
          Call Type:
        </strong>
        <span>
          {call.CALL_TYPE}
        </span>
        <strong>
          Country Code:
        </strong>
        <span>
          {call.CC}
        </span>
        <strong>
          Normalized Code:
        </strong>
        <span>
          {call.NC}
        </span>
      </div>
    );
  }

  onRenderBody() {
    const call = this.state.call;
    const rows = call.rows;
    const callRecords = [];

    if( rows !== undefined ) {
      if( rows.length > 0 ) {
        for( var index = 0; index < rows.length; index++ ) {
          const row = rows[ index ];
          let rowClassName = 'anitrace-records-grid-body-row';
          if( index % 2 === 1 ) {
            rowClassName = 'anitrace-records-grid-body-row alt';
          }
          const rowKey = 'anitrace-records-grid-body-row-' + index.toString();
          callRecords.push(
            <span key={rowKey} className={rowClassName}>
              <span style={{"gridColumn":"1 / 2"}}>
                {row.TRACE}
              </span>
              <span style={{"gridColumn":"2 / 3"}}>
                {row.REQUEST_DATE}
              </span>
              <span style={{"gridColumn":"3 / 4"}}>
                {row.CreateOn_Date}
              </span>
              <span style={{"gridColumn":"4 / 5"}}>
                {row.IPDNIS}
              </span>
              <span style={{"gridColumn":"5 / 6"}}>
                {row.PDNIS}
              </span>
              <span style={{"gridColumn":"6 / 7"}}>
                {row.DIRECTIVE}
              </span>
              <span style={{"gridColumn":"7 / 8"}}>
                {row.LAST_DIRECTIVE}
              </span>
              <span style={{"gridColumn":"8 / 9"}}>
                {row.TOTAL_SECS}
              </span>
              <label style={{"gridColumn":"1 / 9","gridRow":"2 / 3"}}>
                <span>
                  {this.parseMessage( row.MESSAGE )}
                </span>  
              </label>
            </span>                        
          );
        }
      }
    }

    return (
      <div className="anitrace-records-grid">
        <span className="anitrace-records-grid-header">
          <span style={{"gridColumn":"1 / 2"}}>
            TRACE
          </span>
          <span style={{"gridColumn":"2 / 3"}}>
            REQUESTED
          </span>
          <span style={{"gridColumn":"3 / 4"}}>
            CREATED
          </span>
          <span style={{"gridColumn":"4 / 5"}}>
            IPDNIS
          </span>
          <span style={{"gridColumn":"5 / 6"}}>
            PDNIS
          </span>
          <span style={{"gridColumn":"6 / 7"}}>
            DIRECTIVE
          </span>
          <span style={{"gridColumn":"7 / 8"}}>
            LAST DIRECTIVE
          </span>
          <span style={{"gridColumn":"8 / 9"}}>
            TOTAL SECONDS
          </span>
        </span>
        <span className="anitrace-records-grid-body">
          {callRecords}      
        </span>
      </div>
    );
  }

  onRenderFooter( ) {
    return (
      <button className="dialog-save-button" onClick={this.onHandleClose}>
        Close
      </button>
    );
  }

  render( ) {
    const call = this.state.call;
    let caption = 'CALL RECORDS FOR ' + call.ANI;
    return (
      <div className="anitrace-records-dialog">
        <Overlay show={this.state.show} />
        <Dialog show={this.state.show} width={this.state.width} height={this.state.width}>
          <DialogHeader caption={caption} closeButton onClose={this.onHandleClose} />
          <DialogBody>
            <div style={{"margin":"10px"}}>
              {this.onRenderInfo()}
              {this.onRenderBody()}
            </div>              
          </DialogBody>
          <DialogFooter>
            {this.onRenderFooter()}
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
};

export default AniTraceRecordsDialog;


// WEBPACK FOOTER //
// ./src/content/enterprise/anitrace/components/AniTraceRecordsDialog.js